/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./offerList.vue?vue&type=template&id=a144d1de&scoped=true&"
import script from "./offerList.vue?vue&type=script&lang=js&"
export * from "./offerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a144d1de",
  null
  
)

export default component.exports